/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ChatTokenQueryVariables = Exact<{ [key: string]: never }>;

export type ChatTokenQuery = { readonly chatToken: { readonly token: string } | null };

export const ChatTokenDocument = gql`
  query ChatToken {
    chatToken {
      token
    }
  }
`;

export function useChatTokenQuery(
  options?: Omit<Urql.UseQueryArgs<ChatTokenQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ChatTokenQuery, ChatTokenQueryVariables>({
    query: ChatTokenDocument,
    ...options,
  });
}
